
const ErrorPage = ()=>{
    return (
        <>
            <h1>An Error Occured</h1>
            <p>error message to display</p>
        </>
    )
}

export default ErrorPage;